import { c as _c } from "react/compiler-runtime";
import { FaroTextField } from "@components/common/faro-text-field/faro-text-field";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
import { updateTeamDetails } from "@store/teams/teams-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { TeamEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
import { isValidTeamName } from "@utils/team-utils";
/** Renders and updates the team name */
export function EditableTeamName(t0) {
  const $ = _c(16);
  const {
    team,
    isEditable
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const dispatch = useAppDispatch();
  const [hasError, setHasError] = useState(false);
  let t1;
  if ($[0] !== dispatch || $[1] !== team.id || $[2] !== team.name || $[3] !== trackEvent) {
    t1 = async function onUpdateName(value) {
      trackEvent({
        name: TeamEvents.changeTeamDetails,
        props: {
          newNameLength: value.length,
          attribute: "name"
        }
      });
      try {
        await dispatch(updateTeamDetails({
          teamId: team.id,
          payload: {
            name: value
          }
        }));
        return value;
      } catch {
        return team.name ?? "";
      }
    };
    $[0] = dispatch;
    $[1] = team.id;
    $[2] = team.name;
    $[3] = trackEvent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onUpdateName = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function validateTeamName(inputValue) {
      if (isValidTeamName(inputValue)) {
        setHasError(false);
        return true;
      }
      setHasError(true);
      return false;
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const validateTeamName = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = capitalizeFirstLetter(TEAM_DISPLAY_NAME);
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !isEditable;
  let t5;
  if ($[7] !== onUpdateName) {
    t5 = value_0 => onUpdateName(value_0.trim());
    $[7] = onUpdateName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setHasError(false);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = hasError ? "Shouldn't contain (,) or (;)" : "";
  let t8;
  if ($[10] !== hasError || $[11] !== t4 || $[12] !== t5 || $[13] !== t7 || $[14] !== team.name) {
    t8 = <FaroTextField ariaLabel={t3} initialValue={team.name} faroVariant="main" fontSize="1.125rem" isReadOnly={t4} shouldShowTooltip={true} minInputLength={2} onConfirmed={t5} onCancel={t6} validate={validateTeamName} hasError={hasError} helperText={t7} shouldShowCharacterCount={true} maxInputLength={50} />;
    $[10] = hasError;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
    $[14] = team.name;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}